var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { Model } from '@/models/Model';
import SubjectRow from '@/components/subject-row/SubjectRow';
import NewSubjectDialog from '@/views/Subjects/Dialogs/NewSubjectDialog';
import ErrorHandler from '@/support/ErrorHandler';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { excludeRoles } from '@/support/ExcludeRoles';
import { sortBy } from 'lodash';
let TopicRow = class TopicRow extends Vue {
    constructor() {
        super(...arguments);
        this.isSelected = false;
        this.isSubjectSelected = {};
        this.isLoadingAllSubjectStatus = false;
        this.visible = {
            actions: true,
        };
        this.subjects = [];
        this.newSubject = null;
        this.editing = false;
        this.orginalName = '';
        this.newSubjectDialog = false;
        this.selectedTopic = null;
        this.panelOpen = false;
        this.isIdpEligible = null;
        this.isFetchingSubjects = false;
        this.topicCount = null;
    }
    get dialogOptions() {
        const topic = this.selectedTopic;
        return {
            title: topic.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.topic') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!topic) {
                            return;
                        }
                        topic
                            .delete()
                            .then(() => {
                            this.editing = false;
                            this.$emit('deleted', topic);
                            this.resetTemporaryVars();
                        })
                            .catch((error) => {
                            topic.name = this.orginalName;
                            this.resetTemporaryVars();
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedTopic = null;
                    },
                },
            },
        };
    }
    get excludeOptions() {
        const topic = this.selectedTopic;
        const isIdpEligible = this.isIdpEligible;
        return {
            title: topic.name || this.$t('dialogOptions.confirmation').toString(),
            text: isIdpEligible ? this.$t('curriculum.area.include.message').toString() : this.$t('curriculum.area.exclude.message').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: isIdpEligible ? this.$t('curriculum.area.include.button').toString() : this.$t('curriculum.area.exclude .button').toString(),
                    action: () => {
                        if (!topic) {
                            return;
                        }
                        topic
                            .update({ is_idp_eligible: isIdpEligible })
                            .then((updatedTopic) => {
                            this.editing = false;
                            this.resetTemporaryVars();
                            this.$emit('topic-update', updatedTopic);
                        })
                            .catch((error) => {
                            topic.name = this.orginalName;
                            this.resetTemporaryVars();
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedTopic = null;
                    },
                },
            },
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        //
        this.visible = { ...{}, ...this.visible, ...this.visibility };
    }
    updateTopic(topic) {
        topic
            .update()
            .then((subject) => {
            this.editing = false;
            this.resetTemporaryVars();
        })
            .catch((error) => {
            topic.name = this.orginalName;
            this.resetTemporaryVars();
        });
    }
    emitSelectedTopic() {
        this.$emit('selectedTopicChanged', this.isSelected);
    }
    deleteTopic(topic) {
        this.selectedTopic = topic;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    resetTemporaryVars() {
        this.orginalName = '';
    }
    isExistingSubject(subject) {
        return this.selectedSubjects.some((selected) => selected.id === subject.id);
    }
    handleSubjectDeleted(deletedSubject) {
        const key = this.subjects.findIndex((subject) => subject.id === deletedSubject.id);
        this.subjects.splice(key, 1);
    }
    storeSelectedSubject(subject) {
        this.$store.dispatch('selectedChanged', subject);
    }
    fetchSubjects() {
        this.isFetchingSubjects = true;
        if (this.subjects.length > 0) {
            this.isFetchingSubjects = false;
            return;
        }
        new Subject()
            .include(['children', 'level', 'period', 'parent', 'subject_labels'])
            .sort('stage')
            .filter(this.subjectFilters())
            .find(this.topic.id)
            .then((subject) => {
            const subjects = new Model().dataToModel({}, 'Subject', subject.children);
            this.subjects = sortBy(subjects, [(item) => (item.level && item.level.value) || 0, (item) => (item.period && item.period.value) || 0, 'name']);
            if (this.isSelected) {
                this.onSelectionChanged(this.isSelected);
            }
            this.isFetchingSubjects = false;
            return;
        });
    }
    handleNewSubject(event) {
        const subject = event.subject;
        this.subjects.push(subject);
    }
    refechSubjects() {
        new Subject()
            .include(['children', 'level', 'period', 'parent'])
            .filter(this.subjectFilters())
            .find(this.topic.id)
            .then((subject) => {
            this.subjects = new Model().dataToModel({}, 'Subject', subject.children);
        });
    }
    subjectFilters() {
        const filter = {};
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null || this.filters[key].length === 0) {
                return;
            }
            if (this.filters[key].value) {
                filter[key] = this.filters[key].value;
            }
            else {
                filter[key] = this.filters[key];
            }
        });
        return filter;
    }
    changeEligibility(topic, isIdpEligible) {
        this.selectedTopic = topic;
        this.isIdpEligible = isIdpEligible;
        this.$store.dispatch('openDialog', this.excludeOptions);
    }
    async toggleAllSubjectStatus() {
        this.isLoadingAllSubjectStatus = true;
        for (const subject of this.subjects) {
            this.$refs[`subject-${subject.id}`][0].displaySummary();
        }
        for (let index = 0; index < this.subjects.length; index++) {
            const subject = this.subjects[index];
            await this.$refs[`subject-${subject.id}`][0].showSubjectSummary();
        }
        this.isLoadingAllSubjectStatus = false;
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        return this.user && this.user.isTeacherWithExpertRights();
    }
    filterChange() {
        if (this.panelOpen) {
            this.refechSubjects();
        }
    }
    handleSelectedSubject(subject) {
        console.log('this.handleSelectedSubject', subject);
    }
    onSelectionChanged(value) {
        if (!this.subjects.length) {
            this.panelOpen = true;
        }
        this.$nextTick(() => {
            this.$nextTick(() => {
                if (this.subjects.length) {
                    for (const subject of this.subjects) {
                        this.$refs[`subject-${subject.id}`][0].toggleSelected(this.isSelected);
                    }
                }
            });
        });
        this.subjects.forEach((subject) => {
            if (subject.id) {
                this.$set(this.isSubjectSelected, subject.id, value);
            }
        });
        this.emitSelectedTopic();
    }
    panelStateChange(isOpen) {
        if (isOpen) {
            this.fetchSubjects();
        }
    }
    onClearSelection(selectedTopics) {
        if (!selectedTopics.some((topic) => topic.id === this.topic.id)) {
            this.isSelected = false;
        }
    }
    totalSubjectCountChanged() {
        if (!this.totalSubjectCount) {
            return;
        }
        Object.keys(this.totalSubjectCount.topics).forEach((key) => {
            if (this.topic.id === key && this.totalSubjectCount) {
                this.topicCount = this.totalSubjectCount.topics[key];
            }
        });
    }
};
__decorate([
    Prop({ default: new Subject() }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], TopicRow.prototype, "topic", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], TopicRow.prototype, "hasLink", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TopicRow.prototype, "selectable", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TopicRow.prototype, "isCurriculum", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", typeof (_b = typeof Object !== "undefined" && Object) === "function" ? _b : Object)
], TopicRow.prototype, "filters", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", Object)
], TopicRow.prototype, "visibility", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TopicRow.prototype, "infoVisible", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], TopicRow.prototype, "totalSubjectCount", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], TopicRow.prototype, "selectedSubjects", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TopicRow.prototype, "disabled", void 0);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TopicRow.prototype, "filterChange", null);
__decorate([
    Watch('isSelected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TopicRow.prototype, "onSelectionChanged", null);
__decorate([
    Watch('panelOpen'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TopicRow.prototype, "panelStateChange", null);
__decorate([
    Watch('$store.state.selectedTopics', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], TopicRow.prototype, "onClearSelection", null);
__decorate([
    Watch('totalSubjectCount'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TopicRow.prototype, "totalSubjectCountChanged", null);
TopicRow = __decorate([
    Component({
        components: {
            SubjectRow,
            NewSubjectDialog,
            LoaderCard,
        },
    })
], TopicRow);
export default TopicRow;
